import type { ModuleUI } from '../engine/module';
import { financeModule } from './finance';
import { crmModule } from './crm';
import { servicedeskModule } from './servicedesk';
import { schedulingModule } from './scheduling';
import { intakeModule } from './intake';
import { aiModule } from './ai';
import { projectsModule } from './projects';
import { quotingModule } from './quoting';
import { emailModule } from './email';
import { feedbackModule } from './feedback';
import { supportModule } from './support';
import { homeModule } from './home';
import { portalModule } from './portal';
import { platformModule } from './platform';

// Every module's UI, in dependency order. The router, sidebar, palette and breadcrumbs are
// all generated from this list — adding a module is one line here.
export const modules: ModuleUI[] = [platformModule, financeModule, crmModule, servicedeskModule, schedulingModule, intakeModule, aiModule, projectsModule, quotingModule, emailModule, feedbackModule, supportModule, homeModule, portalModule];
